import consumer from './consumer'
import router from '$/router.js'
import { useFeatureStore } from '$/stores/feature.ts'
import { useNotify } from '$/composables/useNotify'

const ua_ip = document.querySelector("meta[name='ua_ip']").getAttribute('content')
const featureStore = useFeatureStore()
const { pushError } = useNotify()

consumer.subscriptions.create(
  { channel: 'ImageProgressChannel', ua_ip: ua_ip },
  {
    connected() {},

    disconnected() {},

    received(data) {
      if (import.meta.env.DEV === true) console.log(data)
      if (data.message) {
        const messageEl = document.getElementById('progressMessage')
        if (messageEl) messageEl.innerText = data.message
      } else if (data.save_folder && featureStore.currentTaskId === data.save_folder) {
        featureStore.results.push(...data.results)

        data.results.forEach((result) => {
          if (result.error) {
            pushError(result.error)
          }
        })

        featureStore.resultTaskId = data.save_folder
        if (data.finished) {
          featureStore.processing = false

          switch (data.feature) {
            case 'face-swap':
              window.scrollTo({
                top: document.getElementById('preview').getBoundingClientRect().top + window.pageYOffset - 100,
                behavior: 'smooth',
              })
              break
            case 'upscale-restore-image':
              if (window.location.pathname.includes('upscale-restore-image')) router.push({ name: 'UpscaleResult' })
              break
            case 'restore-old-photo':
              if (window.location.pathname.includes('restore-old-photo')) router.push({ name: 'RestoreOldPhotoResult' })
              break
            case 'colorize-image':
              if (window.location.pathname.includes('colorize-black-and-white-photo'))
                router.push({ name: 'ColorizeBlackAndWhiteResult' })
              break
            case 'remove-background':
              if (window.location.pathname.includes('remove-background'))
                router.push({ name: 'RemoveBackgroundResult' })
              break
            case 'blur-background':
              if (window.location.pathname.includes('blur-background')) router.push({ name: 'BlurBackgroundResult' })
              break
            case 'trim-transparent':
              if (window.location.pathname.includes('trim-transparent')) router.push({ name: 'TrimTransparentResult' })
              break
            case 'generate-shadow':
              if (window.location.pathname.includes('image-shadow-generator'))
                router.push({ name: 'GenerateShadowResult' })
              break
          }
        }
      }
    },
  }
)
